import { memo } from 'react';
import { Box, Button, Drawer, Grid } from '@mui/material';
import Main from 'components/Main/Main';
import './GestaoCessao.scss';
import { DataGrid, ptBR } from '@mui/x-data-grid';
import useGestaoCessaoHook from './hooks/useGestaoCessaoHook';
import FiltrosTabela from './componentes/FiltrosTabela/FiltrosTabela';
import SkeletonLoadingOverlay from './componentes/SkeletonTabela/SkeletonTabela';
import DetalhesCessao from './DetalhesCessao/DetalhesCessao';

const GestaoCessao = ({ escopoAcesso, setEscopoAcesso }) => {
  const {
    handleRowSelectionModelChange,
    atualizarGridHistoricoCessao,
    handlePaginationModelChange,
    rowSelectionModelFiltered,
    handleSortModelChange,
    setMostrarDetalhes,
    setDadosDetalhes,
    contadorFiltros,
    mostrarDetalhes,
    paginationModel,
    dadosDetalhes,
    irParaJornada,
    toolbarTabela,
    handleFiltrar,
    sortModel,
    rowCount,
    loading,
    columns,
    rows
  } = useGestaoCessaoHook({
    escopoAcesso,
    setEscopoAcesso
  });

  return (
    <Main
      title="Dashboard"
      className="gestao-sessao"
      escopoAcesso={escopoAcesso}
      setEscopoAcesso={setEscopoAcesso}
    >
      <Box className="dashboard">
        <Grid container className="container-sessao">
          <Grid item xs={12}>
            <Box className="sessao-topo">
              <Box className="subtitulo-sessao">
                <Box className="titulo-sessao">Capital Flow - Gestão de títulos</Box>
              </Box>
            </Box>

            <Box className="box-subtitulo-sessao">
              <Grid container>
                <Grid item xs={12} md={9}>
                  <Box className="titulo-sessao">Consulte seu histórico ou inicie uma nova cessão</Box>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Box className="box-btn-sessao">
                    {escopoAcesso?.plataforma_oneshell?.componente['jornada-capital-flow'] && (
                      <Button className="btn-iniciar-sessao" onClick={() => irParaJornada()}>
                        Iniciar nova cessão
                      </Button>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box>
              <Box className="titulo-sessao-grid">Histórico de cessões realizadas</Box>
              <Box className="box-data-grid">
                <FiltrosTabela onFiltrar={handleFiltrar} contadorFiltros={contadorFiltros} />
                <Grid container>
                  <Grid className="content-datagrid-lista-titulos" item xs={12}>
                    <DataGrid
                      rows={rows}
                      columns={columns}
                      loading={loading}
                      className="data-grid-cessao"
                      pageSizeOptions={[10, 25, 50, 100]}
                      disableRowSelectionOnClick
                      rowSelectionModel={rowSelectionModelFiltered}
                      onRowSelectionModelChange={handleRowSelectionModelChange}
                      slots={{
                        toolbar: toolbarTabela,
                        loadingOverlay: SkeletonLoadingOverlay
                      }}
                      localeText={{
                        ...ptBR.components.MuiDataGrid.defaultProps.localeText
                      }}
                      paginationMode="server"
                      paginationModel={paginationModel}
                      onPaginationModelChange={handlePaginationModelChange}
                      sortingMode="server"
                      sortModel={sortModel}
                      onSortModelChange={handleSortModelChange}
                      rowCount={rowCount}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Drawer
          anchor="right"
          className="drawer-detalhes-cessao"
          open={mostrarDetalhes}
          onClose={() => setMostrarDetalhes(false)}
          hideBackdrop
          ModalProps={{
            keepMounted: true
          }}
          PaperProps={{
            className: 'detalhes-drawer-paper'
          }}
        >
          <DetalhesCessao
            atualizarGridHistoricoCessao={atualizarGridHistoricoCessao}
            setMostrarDetalhes={setMostrarDetalhes}
            setDadosDetalhes={setDadosDetalhes}
            dadosDetalhes={dadosDetalhes}
            irParaJornada={irParaJornada}
            escopoAcesso={escopoAcesso}
          />
        </Drawer>
      </Box>
    </Main>
  );
};

export default memo(GestaoCessao);
